import React from "react";
import "./facilited.scss";

//Imagens:
import ImgFacilited from "../../../../assets/dataManagement/figuraDataManagement.png";
import { useTranslation } from "react-i18next";

function Facilited() {
  const { t } = useTranslation()

  return (
    <div className="container-facilited">
      <div className="img-facilited">
        <img src={ImgFacilited} alt="" />
      </div>
      <div className="texts-facilited">
        <h1>{t("data_management.title")}</h1>
        <p>{t("data_management.section_text")}</p>
        <a href="/form" style={{ textDecoration: "none" }}><button id="btn-facilited">{t("buttons.demo_btn_alternative_text_1")}</button></a>
      </div>
    </div>
  );
}

export default Facilited;
